module.exports = __webpack_public_path__ + "static/img/bg-overview@w.7d5a0e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/design-samsung/bg-overview@w.jpg
// module id = I+y3
// module chunks = 0